<template>
  <div class="course-result-detail-contain">
    <article class="operate-contain clearfix">
      <el-button type="primary" class="operate-button" @click="exportDetail">
        {{ $t("export") }}
      </el-button>
      <div class="operate-name">{{ $t('courseTask.courseResult') }}</div>
      <div class="operate-types clearfix">
        <span :class="['operate-types-name', {'operate-types-name2': index === 0, 'active': tabIndex === index }]"
        v-for="(item, index) in typeList" :key="'tab1'+index" @click="choseType(index)">{{ item }}</span>
      </div>
      <div class="operate-module">
        <div class="operate-name operate-name2" @click="showCourseModal">
          {{ $t('courseSchedule.courseAndPackage') }}
        </div>
        <div class="operate-select">
          <el-input :placeholder="$t('user.select')"
                    clearable
                    readonly
                    v-model.trim="teamName"></el-input>
        </div>
      </div>
      <div class="operate-module operate-module2" v-if="tabIndex === 0">
        <div class="operate-name">{{ $t('courseTask.isImportdes') }}</div>
        <div class="operate-select operate-select2">
          <el-select v-model="isImport" @change="changeType" clearable>
            <el-option
              v-for="item,index in typList2"
              :key="'type'+item + index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <el-button type="primary" size="mini" class="operate-import" :loading="importLoading" @click="importSchedule"
        v-if="tabIndex === 0 && $hasPermission('AUTHIMPORTSCHEDULE')">{{ $t('courseTask.importSchedule') }}
      </el-button>
      <el-button type="primary" size="mini" class="operate-import operate-import2" :loading="improveLoading" @click="improveResult"
        v-if="$hasPermission('AUTHIMPROVERESULT')">
        {{ $t('courseTask.resultImprove') }}
      </el-button>
    </article>
    <article class="detail-list">
      <el-table v-loading="dataLoading" border class="result-table" ref="resultDetailTable" :height="calHeight"
      :data="detailData" stripe :row-key="getRowKeys" @select="selectMuti"
      :tree-props="{ children: 'children' }"
      :cell-style="cellStyle" @select-all="selectAll">
        <el-table-column
          header-align="center"
          align="center"
          fixed="left"
          width="60">
        </el-table-column>
        <el-table-column
          type="index"
          :label="$t('pop.no')"
          header-align="center"
          align="center"
          fixed="left"
          width="55">
          <template slot-scope="scope">
            {{ initIndex(scope.row.indexNo) }}
          </template>
        </el-table-column>
        <template v-for="(item,kindex) in columnList">
          <el-table-column :prop="item.prop"
                        :key="'result'+item.prop+ kindex"
                        show-overflow-tooltip
                        :width="item.width"
                        header-align="center"
                        align="center"
                        :fixed="item.fixed"
                        :formatter="item.formatter"
                        :label="item.label">
          </el-table-column>
        </template>
        <!-- 操作 -->
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          fixed="right"
          width="50"
          v-if="tabIndex===0"
          :selectable="checkDisable"
        ></el-table-column>
      </el-table>
    </article>
    <article class="detail-footer">
      <el-pagination
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </article>
    <!-- 错误弹出 -->
    <errorScheduleModal 
      v-if="errorVisible"
      :errorVisible="errorVisible"
      @closeModal="closeError"
      :errorData="errorData"
      :taskName="taskName">
    </errorScheduleModal>
    <!-- 课程选择弹框 -->
    <courseModal v-if="courseShow" 
      :dialogShow="courseShow"
      :taskId="taskId"
      :courseList="courseList"
    @closeCourseChose="closeCourseChose"></courseModal>
  </div>
</template>
<script>
import errorScheduleModal from './scheduleTaskCheckModal.vue';
import courseModal from './courseTaskResultModal.vue';
export default {
  components: {
    errorScheduleModal,
    courseModal
  },
  props: {
    taskId: {
      type: String
    },
    taskName: {
      type: String
    }
  },
  data() {
    return {
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      groupTypeList: [],
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      tabIndex: 0,
      typeList: [this.$t('schedule.statusLog1'), this.$t('schedule.statusLog0')],
      dataLoading: false,
      detailData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      timeout: null,
      calWidth: 300,
      teamName: '',
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      columnList: [],
      columnList1: [
        { label: this.$t('courseSchedule.courseClass'), prop: 'courseTypeName', fixed: 'left' },
        { label: this.$t('courseTask.courseGroupIndex'), prop: 'coursePkgCode', width: 180, fixed: 'left' },
        { label: this.$t('courseTask.courseGroupName'), prop: 'coursePkgName', width: 180, fixed: 'left' },
        { label: this.$t('couse.coursecode'), prop: 'courseCode', width: 120 },
        { label: this.$t('couse.coursenamecn'), prop: 'courseName', width: 120 },
        { label: this.$t('course.courseTeamCatalogId'), prop: 'courseCatalogNames', width: 120 },
        { label: this.$t('couse.startdate1'), prop: 'scheduleDateStart', width: 155 },
        { label: this.$t('couse.endData1'), prop: 'scheduleDateEnd', width: 155 },
        { label: this.$t('courseTask.needTrainer'), prop: 'needTrainerNames', width: 110 },
        { label: this.$t('courseTask.needClass'), prop: 'needClassroomNames' },
        { label: this.$t('courseTask.stieName2'), prop: 'siteAbbr', width: 100 }
      ],
      columnList2: [
        { label: this.$t('courseSchedule.courseClass'), prop: 'courseTypeName', fixed: 'left' },
        { label: this.$t('courseTask.courseGroupIndex'), prop: 'coursePkgCode', width: 180, fixed: 'left' },
        { label: this.$t('courseTask.courseGroupName'), prop: 'coursePkgName', width: 180, fixed: 'left'},
        { label: this.$t('couse.coursenamecn'), prop: 'courseName', width: 120 },
        { label: this.$t('course.courseTeamCatalogId'), prop: 'courseCatalogNames', width: 120 },
        { label: this.$t('couse.coursecode'), prop: 'courseCode', width: 120 },
        { label: this.$t('courseTask.failReason'), prop: 'failReason' },
        { label: this.$t('courseTask.targetAreaFail'), prop: 'siteAbbr', width: 140 }
      ],
      multipleSelection: [],
      errorVisible: false,
      errorData: {},
      calHeight: 400,
      importLoading: false,
      courseShow: false,
      courseList1: [],
      courseList2: [],
      courseList: [],
      isImport: null,
      downLoading: false,
      expandKeys: [],
      typList2: [
        { name: this.$t('courseTask.isImportN'), value: 0 },
        { name: this.$t('courseTask.isImportY'), value: 1 }
      ]
    };
  },
  methods: {
    showCourseModal () {
      this.courseShow = true;
    },
    changeType () {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDetailData();
    },
    closeCourseChose (val) {
      this.courseShow = false;
      if (val.courseInfo.length > 0) {
        this.teamName = val.courseInfo.map((item) => item.courseName).toString();
        this.courseList = val.courseInfo;
        this.courseList2 = val.courseInfo.filter((item) => {
          return item.courseTypeKey === 1 || item.courseTypeKey === 2;
        }).map((item) => {
          return item.courseId;
        });
        this.courseList1 = val.courseInfo.filter((item) => {
          return !(item.courseTypeKey === 1|| item.courseTypeKey === 2);
        }).map((item) => {
          return item.courseId;
        });
      } else {
        this.teamName = '';
        this.courseList = [];
        this.courseList2 = [];
        this.courseList1 = [];
      }
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDetailData();
    },
    checkPermission (val) {
      const dic = 'SC_TARGET_NEW:' + val;
      if (JSON.parse(sessionStorage.getItem('v1user_data')).userCode === 'admin') {
        return true;
      }
      return this.$hasPermission(dic);
    },
    choseType (val) {
      this.tabIndex = val;
      this.columnList = val === 0 ? this.columnList1 : this.columnList2;
      this.detailData = [];
      this.getDetailData();
    },
    initIndex(val) {
      return val ? (this.pageNum - 1) * this.pageSize + val : '';
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDetailData();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDetailData();
    },
    getDetailData () {
      const params = {
        scheduleTaskId: this.taskId,
        teamCatalogSeconds: this.groupTypeList.toString(),
        courseIds: this.courseList1,
        pkgIds: this.courseList2,
        page: this.pageNum,
        status: this.isImport,
        limit: this.pageSize
      };
      if (this.taskId) {
        if (this.tabIndex === 0) {
          this.getSuccessData(params);
        } else {
          this.multipleSelection = [];
          this.getWrongData(params);
        }
      }
    },
    checkDisable (row) {
      let checkFlg = false;
      if (row.status !== 1 && this.checkPermission(row.courseCatalogSecond) && !row.isChildSplit ) {
        checkFlg = true;
      }
      return checkFlg;
    },
    querSelect () {
      const selectionIds = this.multipleSelection.map((item) => {
        return item.uid; 
      });
      this.detailData.forEach((item) => {
        if (selectionIds.includes(item.uid)) {
          this.$refs.resultDetailTable.toggleRowSelection(item);
          if (item.children) {
            item.children.forEach((i) => {
              if (selectionIds.includes(i.uid)) {
                this.$refs.resultDetailTable.toggleRowSelection(i);
              }
            });
          }
        }
      });
    },
    getRowKeys(row) {
      return row.uid;
    },
    getSuccessData (params) {
      this.dataLoading = true;
      this.$request.post('/classschedule/scheduleTaskResult/queryExecuteResultInfoDetail', params).then((res) => {
        if (res) {
          this.total = res.total;
          this.detailData = res.records.map((item, index) => {
            item.uid = item.id;
            if (!item.children) {
              delete item.children;
            } else {
              item.children = item.children.map((i, kindex) => {
                i.isChildSplit = !item.courseType || (item.courseType === 'courseGroupType2' && !i.children);
                i.uid = `children${  kindex  }${i.scheduleInfoDetailId || i.id}`;
                i.parentId = item.uid;
                if (i.children) {
                  i.children = i.children.map((k, kindex2) => {
                    k.uid = `schildren${  k.scheduleInfoDetailId  }${kindex2}` ;
                    k.isChildSplit = i.courseType === 'courseGroupType2';
                    delete k.children;
                    return k;
                  });
                } else {
                  delete i.children;
                } 
                return i;
              });
            }
            item.indexNo = index + 1;
            return item;
          });
          this.$nextTick(() => {
            this.querSelect();
          });
        }
        this.dataLoading = false;
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    getWrongData (params) {
      this.dataLoading = true;
      this.$request.post('/classschedule/scheduleTaskResult/queryFailResultInfoDetail', params).then((res) => {
        if (res) {
          this.total = res.total || 0;
          this.detailData = res.records.map((item, index) => {
            item.uid = item.id;
            if (!item.children) {
              delete item.children;
            } else {
              item.children = item.children.map((i,kindex) => {
                i.uid = `children${  kindex  }${i.id}`;
                if (i.children) {
                  i.children = i.children.map((k, kindex2) => {
                    k.uid = `schildren${  k.id  }${kindex2}`;
                    delete k.children;
                    return k;
                  });
                } else {
                  delete i.children;
                } 
                return i;
              });
            }
            item.indexNo = index + 1;
            return item;
          });
        }
        this.dataLoading = false;
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    cellStyle ({ row, column }) {
      if (column.type === 'selection' && row.isChildSplit) {
        return { opacity: 0 };
      }
    },
    selectMuti (_selection, row) {
      let ids = this.multipleSelection.map((item) => item.uid);
      if(!ids.includes(row.uid)) {
        this.multipleSelection.push(row);
        ids.push(row.uid);
        if (row.children && row.children.length > 0) {
          row.children.forEach((i) => {
            if (!ids.includes(i.uid) && i.uid.indexOf('schildren') === -1 && !i.isChildSplit) {
              this.multipleSelection.push(i);
              ids.push(i.uid);
              this.$refs.resultDetailTable.toggleRowSelection(i, true);
            }
          });
        }
        if (row.parentId) {
          const parentData = this.detailData.filter((item) => item.uid === row.parentId)[0];
          let flag = 0;
          parentData.children.forEach((item) => {
            if (ids.includes(item.uid)) {
              flag ++;
            }
          });
          if (flag === parentData.children.length) {
            this.$refs.resultDetailTable.toggleRowSelection(parentData, true);
            this.multipleSelection.push(parentData);
          }
        }
      } else {
        // 第二级如果第一级多个 则第一级父删除
        if (row.parentId && ids.includes(row.parentId)) {
          this.multipleSelection.forEach((item,index) => {
            if (item.uid === row.parentId) {
              this.$refs.resultDetailTable.toggleRowSelection(item, false);
              this.multipleSelection.splice(index, 1);
            }
          });
        }
        if (row.children && row.children.length > 0) {
          row.children.forEach((i) => {
            this.$refs.resultDetailTable.toggleRowSelection(i, false);
          });
          const delIds = row.children.map(item => item.uid);
          const farr = [];
          this.multipleSelection.forEach((item) => {
            if (!delIds.includes(item.uid) && !item.isChildSplit) {
              farr.push(item);
            }
          });
          this.multipleSelection = farr;
        }
        ids = this.multipleSelection.map((item) => item.uid);
        this.$refs.resultDetailTable.toggleRowSelection(row, false);
        this.multipleSelection.splice(ids.indexOf(row.uid), 1);
      }
    },
    // 全选功能
    selectAll (selection) {
      const ids = this.multipleSelection.map((item) => item.uid).filter((item) => item.indexOf('schildren') === -1);
      if (selection.length > 0) {
        selection.forEach((item) => {
          if (!ids.includes(item.uid) && !item.isChildSplit) {
            this.multipleSelection.push(item);
            ids.push(item.uid);
          }
        });
      } else {
        const delIds = [];
        this.detailData.map((item) => {
          delIds.push(item.uid);
          if (item.children) {
            item.children.forEach((i) => {
              delIds.push(i.uid);
            });
          }
        });
        const arr = [];
        this.multipleSelection.forEach((item) => {
          if (delIds.includes(item.uid)) {
            this.$refs.resultDetailTable.toggleRowSelection(item, false);
          } else{
            arr.push(item);
          }
        });
        this.multipleSelection = arr;
      }
    },
    importSchedule () {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: this.$t('courseTask.importScheduleInfo'),
          type: 'warning'
        });
        return false;
      }
      const mArr = this.multipleSelection.filter((item) => {
        return item.uid.indexOf('schildren') === -1;
      }).filter((item) => item.status === 0);
      const ids = mArr.map((item) => item.uid);
      const obj = {};
      mArr.forEach((item) => {
        obj[item.uid] = item;
      });
      const data =  [];
      const lastIds = [];
      mArr.forEach((item) => {
        if (item.parentId) {
          if (ids.includes(item.parentId)) {
            if (!lastIds.includes(item.parentId)) {
              data.push(obj[item.parentId]);
              lastIds.push(item.parentId);
            }
          } else {
            data.push(item);
            lastIds.push(item.uid);
          }
        } else {
          if (!lastIds.includes(item.uid)) {
            data.push(item);
            lastIds.push(item.uid);
          }
        }
      });
      const selections = data.map((item) => {
        const fids = [];
        if (item.children) {
          item.children.map((i) => {
            if (i.status !== 1) {
              if (i.courseType === 'courseGroupType2') {
                fids.push(i.children.map((k) => k.scheduleInfoDetailId));
              } else {
                fids.push([i.scheduleInfoDetailId]);
              }
            }
          });
        } else {
          fids.push([item.scheduleInfoDetailId]);
        }
        return { scheduleInfoId: item.id, scheduleInfoDetailIds: fids };
      });
      this.importLoading = true;
      this.$request.post('/classschedule/scheduleTaskResult/publishArrangeResult', selections).then((res) => {
        if (res) {
          if (res.status === -1) {
            this.importLoading = false;
            this.errorVisible = false;
            this.errorData = null;
            this.$message({
              message: res.message,
              type: 'warning',
            });
          } else {
            this.errorData = res;
            this.errorVisible = true;
            this.importLoading = false;
          }
        }
      }).catch(() => {
        this.importLoading = false;
      });
    },
    closeError () {
      this.errorVisible = false;
      this.multipleSelection = [];
      this.errorData = null;
      this.getDetailData();
    },
    exportDetail () {
      this.downLoading = false;
      const params = {
        scheduleTaskId: this.taskId,
        teamCatalogSeconds: this.groupTypeList.toString(),
        courseIds: this.courseList1,
        pkgIds: this.courseList2,
        status: Number(this.tabIndex) === 0 ? this.isImport : null,
      };
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/exportTaskResultDetail',
        `${this.taskName + this.$t('courseTask.resultTab2')  }.xls`,
        params, null, 'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downLoading = false;
      }, 2000);
    },
    improveResult () {
      this.improveLoading = true;
      this.$request.post(`/classschedule/courseArrange/optimizeArrangeResult?scheduleTaskId=${this.taskId}`).then((res) => {
        this.improveLoading = false;
        this.$message({
          message: this.$t('courseTask.resultImproveSuccess'),
          type: 'success',
        });
        this.getDetailData();
      }).catch(() => {
        this.improveLoading = false;
      });
    }
  },
  mounted() {
    this.columnList = this.columnList1;
    setTimeout(() => {
      this.calHeight = window.innerHeight - 100 < 593 ? window.innerHeight : 593;
    });
    window.onresize = () => {
      setTimeout(() => {
        this.calHeight = window.innerHeight - 100 < 593 ? window.innerHeight : 593;
      });
    };
    this.getDetailData();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.timeout = null;
  },
};
</script>
<style lang="scss">
.course-result-detail-contain {
  .operate-contain {
    height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    overflow: hidden;
    .operate-button {
      display: block;
      float: left;
    }
    .operate-name {
      float: left;
      margin: 0 10px 0 30px;
      color: #333333;
      &.operate-name2 {
        color: #409eff;
        cursor: pointer;
        &:hover {
          opacity: .8;
        }
      }
    }
    .operate-select {
      float: left;
      width: 180px;
      &.operate-select2 {
        width: 120px;
      }
    }
    .operate-types {
      float: left;
      border: 1px solid #e9e9eb;
      color: #909399;
      border-radius: 3px;
      height: 34px;
      box-sizing: border-box;
      .operate-types-name {
        display: block;
        float: left;
        padding: 0 20px;
        cursor: pointer;
        &.operate-types-name2 {
          border-right: 1px solid #e9e9eb;
        }
        &.active {
          background-color: #ecf5ff;
          color: #409eff;
        }
      }
    }
  }
  .operate-import {
    float: right;
    &.operate-import2 {
      margin-right: 12px;
    }
  }
  .detail-list {
    .result-detail-table {
      width: 100%;
    }
  }
  .detail-footer {
    text-align: right;
  }
}
</style>